module.exports = __webpack_public_path__ + "img/5or10.89eda140.png";